import { render } from "./PaymentFail.vue?vue&type=template&id=e4323b7a&scoped=true"
import script from "./PaymentFail.vue?vue&type=script&lang=js"
export * from "./PaymentFail.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=e4323b7a&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=e4323b7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4323b7a"]])

export default __exports__